"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InstagramDmIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.155 2.578C.438 2.025.818.85 1.714.85h12.833c.687 0 1.137.74.84 1.377L9.414 15.006c-.395.844-1.61.666-1.759-.259L6.334 6.58l-5.18-4.002zm2.177-.212L7.07 5.253l4.981-2.887H3.332zm9.85 1.084l-4.355 9.318-1.005-6.212 5.36-3.106z",
    clipRule: "evenodd"
  })))
});
InstagramDmIcon.displayName = 'InstagramDmIcon';
var _default = exports.default = InstagramDmIcon;